module.exports = __webpack_public_path__ + "media/images/athletes/1317-5db32ebc02d593c839f20c8748292858.png";